import 'isomorphic-fetch';
import { HTTP_METHODS } from '../../constants/http';
import MLPServiceClient from '../clients/MLPServiceClient';
import { constructResponseError } from '../api/apiUtils';
import keycloak from './keycloak';

const isMClassUser = () => {
    if (keycloak.tokenParsed && keycloak.tokenParsed.migrationStatus) {
        return !keycloak.tokenParsed.migrationStatus.usesOnboarding;
    }

    // For backward compatibility
    return keycloak.tokenParsed && keycloak.tokenParsed.mclassUserSid !== undefined;
};

const isMigrationFailed = () =>
    keycloak.tokenParsed &&
        keycloak.tokenParsed.migrationStatus &&
        keycloak.tokenParsed.migrationStatus.status !== 'SUCCESS';

/**
 * Hit MAS_TOKEN endpoint to get / update sso.auth_token cookie
  */
const updateMasToken = () => {
    const postConfig = {
        method: HTTP_METHODS.POST,
        headers: {
            Accept: 'application/json',
            'content-type': 'application/x-www-form-urlencoded',
        },
        body: `kc_access_token=${keycloak.token}`,
        credentials: 'include',
    };
    return fetch(MLPServiceClient.MAS_TOKEN, postConfig).then(
        response => {
            if (response.ok) {
                return Promise.resolve();
            }
            return Promise.reject(constructResponseError(response));
        },
        error => {
            return Promise.reject(error);
        }
    );
};

/**
 * Check and refresh (if needed) keycloack and mAS tokens
 */
export const checkRefreshToken = () => (
    keycloak.updateToken().then(
        refreshed => refreshed && (isMClassUser()) ? updateMasToken() : Promise.resolve()
    ).catch(
        // ignore network / refresh errors since the downstream code has all error handling
        () => Promise.resolve()
    )
);

export { updateMasToken, isMClassUser, isMigrationFailed };
